var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { forwardRef } from 'react';
import cn from 'classnames';
import styles from 'core-components/src/components/textfield/textfield.scss';
const CrossIcon = props => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "34.001", height: "34", viewBox: "0 0 34.001 34" }, props),
    React.createElement("g", { id: "Group_308", "data-name": "Group 308", transform: "translate(-311 -2011)" },
        React.createElement("g", { id: "Group_306", "data-name": "Group 306", transform: "translate(312 2012)" },
            React.createElement("path", { id: "Path_309", "data-name": "Path 309", d: "M-1085.086,3123.242l32,32", transform: "translate(1085.086 -3123.242)", fill: "none", stroke: "#000", strokeLinecap: "round", strokeWidth: "2" }),
            React.createElement("path", { id: "Path_310", "data-name": "Path 310", d: "M0,0,32,32", transform: "translate(0.001 32) rotate(-90)", fill: "none", stroke: "#000", strokeLinecap: "round", strokeWidth: "2" })))));
export const TextField = forwardRef((_a, ref) => {
    var { raised, invalid, small, big, fluid, iconAtRight, loading, clearable, onClear, icon, className } = _a, nativeProps = __rest(_a, ["raised", "invalid", "small", "big", "fluid", "iconAtRight", "loading", "clearable", "onClear", "icon", "className"]);
    const coreStyles = cn({
        [styles.textfield]: true,
        [styles.raised]: raised,
        [styles.invalid]: invalid,
        [styles.small]: small,
        [styles.big]: big,
        [styles.fluid]: fluid,
        [styles.iconAtRight]: iconAtRight,
        [styles.loading]: loading,
        [styles.clearable]: clearable,
        [className]: className
    });
    const thisOnClear = (e) => {
        const originalTarget = e.target;
        const newTarget = originalTarget.nextElementSibling;
        Object.defineProperty(e, 'target', { value: newTarget });
        onClear(e);
    };
    let thisIcon = null;
    if (iconAtRight) {
        const isNotEmpty = typeof nativeProps.value === 'string' && nativeProps.value.length;
        if (isNotEmpty) {
            thisIcon = (React.createElement("button", { type: "button", onClick: thisOnClear, className: styles.clear },
                React.createElement(CrossIcon, { height: "12px", width: "12px", fill: "#555", style: { display: 'block' } })));
        }
        return (React.createElement("div", { className: coreStyles },
            icon && isNotEmpty && clearable
                ? thisIcon
                : React.cloneElement(icon, { 'data-icon': '' }),
            React.createElement("input", Object.assign({}, nativeProps, { ref: ref })),
            React.createElement("div", { className: styles.loadingAnimation },
                React.createElement("div", null),
                React.createElement("div", null),
                React.createElement("div", null))));
    }
    return (React.createElement("div", { className: coreStyles },
        icon ? React.cloneElement(icon, { 'data-icon': '' }) : null,
        clearable &&
            (nativeProps.value && nativeProps.value.length > 0) ? (React.createElement("button", { type: "button", onClick: thisOnClear, className: styles.clear },
            React.createElement(CrossIcon, { height: "10px", width: "10px", fill: "#555", style: { display: 'block' } }))) : null,
        React.createElement("input", Object.assign({}, nativeProps, { ref: ref })),
        React.createElement("div", { className: styles.loadingAnimation },
            React.createElement("div", null),
            React.createElement("div", null),
            React.createElement("div", null))));
});
TextField.defaultProps = {
    raised: false,
    invalid: false,
    big: false,
    fluid: false,
    iconAtRight: false,
    loading: false,
    clearable: false,
    onClear: () => {
        /* IMPLEMENTED BY USER */
    },
    icon: null
};
